export function getContactSchema() {
  return [
    {
      name: "id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: false,
      readOnly: true,
      error: false,
    },
    {
      name: "Name",
      default: "",
      type: "string",
      maxLength: 60,
      selectables: [],
      similair: ["full name", "contact name", "person"],
      nullable: false,
      readOnly: false,
      helperText: "Contact's full name",
      error: false,
    },
    {
      name: "Email",
      default: "",
      type: "string",
      maxLength: 60,
      selectables: [],
      similair: ["email address", "address", "email"],
      nullable: false,
      readOnly: false,
      helperText: "Enter a valid email address",
      error: false,
    },
    {
      name: "Phone Number",
      default: "",
      type: "number",
      maxLength: 60,
      selectables: [],
      similair: ["phone number", "telephone", "mobile"],
      nullable: true,
      readOnly: false,
      helperText: "Enter a valid phone number",
      error: false,
    },
    {
      name: "Role",
      default: "",
      type: "string",
      maxLength: 60,
      selectables: ["Designer", "Contractor", "Owner", "Administrator"],
      similair: ["role", "position", "job title"],
      nullable: false,
      readOnly: false,
      helperText: "Designer, Contractor, Owner, Administrator",
      error: false,
    },
    {
      name: "Collaboration Status",
      default: "",
      type: "string",
      maxLength: 60,
      selectables: [
        "Read Only (No Update, Create, or Delete)",
        "Read and Update Only (No Create or Delete)",
        "Read, Update, and Create Only (No Delete)",
        "Full Control (unlimited access)",
      ],
      similair: ["role", "position", "job title"],
      nullable: false,
      readOnly: false,
      helperText: "Designer, Contractor, Owner, Administrator",
      error: false,
    },
  ];
}
